import React from 'react';
import { Flame } from 'lucide-react';
interface StreakCounterProps {
  count: number;
}
export function StreakCounter({
  count
}: StreakCounterProps) {
  return <div className="flex items-center gap-2 bg-orange-50 dark:bg-orange-900/20 px-3 py-1.5 rounded-full border border-orange-200 dark:border-orange-800" data-id="element-518">
      <Flame className="w-4 h-4 text-orange-500" data-id="element-519" />
      <span className="font-fredoka font-bold text-sm text-orange-600 dark:text-orange-400" data-id="element-520">
        {count}
      </span>
    </div>;
}